import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './GuidanceMediaArea-hashed.scss';
import templateStr from 'text!./GuidanceMediaArea.html';

export default {
    restrict: 'E',
    bindings: {
        selectedOccupation: '<'
    },
    template: cssUtil.hashTemplate(templateStr, styles),
    controller: ['$scope', 'guidance.DynamicContent', function ($scope, dynamicContent) {
        $scope.getCustomImage = dynamicContent.getOccupationImage;
    }]
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/guidance/common/directives/MediaArea/GuidanceMediaArea.js
// module id = 959
// module chunks = 0